import React from "react";
import { Flex, Tooltip, Text, Icon, Box } from "@chakra-ui/react";
import { PropertyItemProps, SubPropertyProps } from "./Property.types";
import { BsCheckLg } from "react-icons/bs";

export default function PropertyItem ({
    label,
    onClick,
    icon,
    tooltipText,
    activePropertyType
}: PropertyItemProps & { activePropertyType?: SubPropertyProps }) {
    return (
        <Tooltip label={label} aria-label={tooltipText} placement={'right-end'}>
            <Flex 
                paddingX='1.5' 
                cursor='pointer' 
                paddingY='1' 
                alignItems="center" 
                marginBottom='0.5' 
                justifyContent='space-between'
                _hover={{ bg: 'gray.100' }}
                onClick={() => onClick && onClick(label)}
            >
                <Flex alignItems="center" >
                    {icon!}
                    <Text size="sm" marginLeft={'1.5'} fontWeight='normal'>{label}</Text>
                </Flex>
                {activePropertyType!.label === label && (
                    <Box>
                        <Icon as={BsCheckLg} color='gray.500' size={'md'} />
                    </Box>
                )}
            </Flex>
        </Tooltip>
    )
}